import { render, staticRenderFns } from "./CardColumnGroup.vue?vue&type=template&id=745317ee"
import script from "./CardColumnGroup.vue?vue&type=script&lang=js"
export * from "./CardColumnGroup.vue?vue&type=script&lang=js"
import style0 from "./CardColumnGroup.vue?vue&type=style&index=0&id=745317ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports